// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('product.pricelists.new', {
        url:'/new',
        views: {"productView@product": {
            templateUrl: 'main/product/pricelists/pricelist/pricelist.tpl.html',
            controller: 'PricelistController as vm'
        }},
        resolve: {
            pricelist: function() { return {}; },
            isNewPricelist: function() { return true; },
            currencies: currenciesResolver,
            psychologicalPrices: psychologicalPriceResolver,
            customerGroups: customerGroupsResolver,
            salesChannels: salesChannelsResolver
        }
    });

    $stateProvider.state('product.pricelists.pricelist', {
        url:'/{pricelistId}',
        views: {"productView@product": {
            templateUrl: 'main/product/pricelists/pricelist/pricelist.tpl.html',
            controller: 'PricelistController as vm'
        }},
        resolve: {
            pricelist: pricelistResolver,
            isNewPricelist: function() { return false; },
            currencies: currenciesResolver,
            psychologicalPrices: psychologicalPriceResolver,
            customerGroups: customerGroupsResolver,
            salesChannels: salesChannelsResolver
        }
    });
}

// @ngInject
function pricelistResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getPricelistBrief($stateParams.pricelistId);
}

// @ngInject
function salesChannelsResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getSalesChannels();
}

// @ngInject
function currenciesResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getCurrencies();
}

// @ngInject
function psychologicalPriceResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getPsychologicalPrices();
}

// @ngInject
function customerGroupsResolver($stateParams, PricelistsApiService) {
    return PricelistsApiService.getCustomerGroups();
}

// @ngInject
function PricelistController($state, $scope, $rootScope, pricelist, loadSpinnerService, PricelistsApiService, isNewPricelist, currencies, psychologicalPrices, customerGroups, $translate, salesChannels, ToasterService) {
    var vm = this;

    //Properties
    var pricelistCopy = {};
    vm.pricelist = pricelist;
    vm.isNewPricelist = isNewPricelist;
    vm.isEditing = vm.isNewPricelist;
    vm.currencies = currencies;
    vm.psychologicalPrices = [{id:0, name: '-'}].concat(psychologicalPrices);
    vm.customerGroups = customerGroups;
    vm.salesChannels = salesChannels;

    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactPricelistView') !== 'false';

    //Methods
    vm.isAllInformationValid = isAllInformationValid;
    vm.isPricelistCodeValid = isPricelistCodeValid;
    vm.isPricelistNameValid = isPricelistNameValid;
    vm.isSalesChannelCodeValid = isSalesChannelCodeValid;
    vm.hasChosenCurrency = hasChosenCurrency;
    vm.savePricelist = savePricelist;
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;

    activate();

    function activate() {
        prepareData();

        if (vm.isNewPricelist) {
            vm.pricelist = {
                exchangeRate: 1,
                priceFactor: 1,
                leastNetProfitPercentage: 0
            };
            vm.pricelist.psychologicalPrice = vm.psychologicalPrices[0];
            vm.pricelist.currency = _.find(vm.currencies, function(o) {
                return o.code = 'SEK';
            });
            vm.pricelist.salesChannel = vm.salesChannels[0];
        }

        $scope.$watch(function() { return vm.pricelist.currency.id; }, function(newValue, oldValue) {
            vm.pricelist.exchangeRate = vm.pricelist.currency.currencyRate;
        });
    }

    function enableEditing() {
        pricelistCopy = angular.copy(vm.pricelist);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.pricelist = pricelistCopy;
        vm.isEditing = false;
    }

    function savePricelist() {
        if (vm.isNewPricelist) {
            saveNewPricelist();
        } else {
            updatePricelist();
        }
    }

    function saveNewPricelist() {
        loadSpinnerService.start('mainSpinner');
        PricelistsApiService.createPricelist(vm.pricelist).then(function(response) {
            vm.pricelist = response;
            prepareData();
            vm.isNewPricelist = false;
            vm.isEditing = false;
            ToasterService.showSuccess('"' + vm.pricelist.pricelistName + '" ' + $translate.instant("common.wasSaved"), $translate.instant("product.pricelists"));
            $rootScope.$emit('Pricelist.Inserted', response);
            $state.go('product.pricelists.pricelist', {pricelistId: response.id});
        }, function(error) {
            ToasterService.showError(error, $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updatePricelist() {
        loadSpinnerService.start('mainSpinner');
        PricelistsApiService.updatePricelist(vm.pricelist).then(function(response) {
            vm.pricelist = response;
            prepareData();
            vm.isEditing = false;
            ToasterService.showSuccess('"' + vm.pricelist.pricelistName + '" ' + $translate.instant("common.wasSaved"), $translate.instant("product.pricelists"));
            $rootScope.$emit('Pricelist.Changed', response);
        }, function(error) {
            ToasterService.showError(error, $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function prepareData() {
        if (vm.pricelist && vm.pricelist.salesChannel && vm.pricelist.salesChannel.id > 0) {
            var salesChannel = _.find(salesChannels, function(o) { return o.id === vm.pricelist.salesChannel.id; });
            if (salesChannel) {
                vm.pricelist.salesChannel = salesChannel;
            }
        }
    }

    function isAllInformationValid() {
        return isPricelistCodeValid() &&
               isPricelistNameValid() &&
               hasChosenCurrency();
    }

    function isPricelistCodeValid() {
        return vm.pricelist.pricelistCode && vm.pricelist.pricelistCode.length > 0;
    }

    function isSalesChannelCodeValid() {
        return vm.pricelist.salesChannel && vm.pricelist.salesChannel.salesChannelCode.length > 0;
    }

    function isPricelistNameValid() {
        return vm.pricelist.pricelistName && vm.pricelist.pricelistName.length > 0;
    }

    function hasChosenCurrency() {
        return vm.pricelist.currency && vm.pricelist.currency.id > 0;
    }
}

angular
    .module('pricelists.pricelist', [])
    .config(stateConfig)
    .controller('PricelistController', PricelistController);
